import React, { useState } from "react";
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  TextField,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ModeOfTravelIcon from "@mui/icons-material/ModeOfTravel";
import AdjustIcon from "@mui/icons-material/Adjust";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import { getPlacesForText } from "../../../services/rest/mapbox/getPlaces";
import toast from "react-hot-toast";
import FmdGoodIcon from "@mui/icons-material/FmdGood";
import {
  setCoordinates,
  setDataRoute,
  setLandMarks,
} from "../../../redux/slice/routeSlice";
import { navigation } from "../../../services/rest/mapbox/navigationMap";
import { useDispatch } from "react-redux";

const FormGenerateNewRoute = ({ setLoading }) => {
  const [optionsPlacesInit, setOptionsPlacesInit] = useState([]);
  const [optionsPlacesEnd, setOptionsPlacesEnd] = useState([]);
  const [initRoute, setInitRoute] = useState("");
  const [endRoute, setEndRoute] = useState("");
  const dispatch = useDispatch();

  const getPlaces = async (text, list) => {
    try {
      if (text === "") {
        return;
      }
      const response = await getPlacesForText({ text });
      if (list === "initRoute") {
        setOptionsPlacesEnd([]);
        setOptionsPlacesInit(response);
      } else if (list === "endRoute") {
        if (Object.keys(initRoute).length === 0) {
          toast.error("Debes seleccionar un punto de inicio primero.");
          return;
        }
        setOptionsPlacesInit([]);
        setOptionsPlacesEnd(response);
      }
      // setOptionsPlacesInit(response ?? []);
    } catch (error) {
      throw error;
    }
  };
  const handlePlaceOption = async (e) => {
    try {
      // setLoading(true);
      const { name, value } = e.target;
      // console.log("Value", e.target.value);
      // console.log("Name", e.target.name);
      await getPlaces(value, name);
      // setLoading(false);
    } catch (error) {
      toast.error(
        "En este momento no se obtuvo respuesta. \n Intentalo más tarde."
      );
    }
  };
  const onPressPlace = async (place, list) => {
    try {
      setLoading(true);
      // console.log("Ubicación seleccionada", place?.geometry?.coordinates);
      // console.log("Lista", list);
      if (list === "initRoute") {
        setInitRoute(place);
        setOptionsPlacesInit([]);
      }
      if (list === "endRoute") {
        setEndRoute(place);
        const coordinates = [
          initRoute?.geometry?.coordinates,
          place?.geometry?.coordinates,
        ];
        // console.log("Coordenadas", coordinates);
        const coordinatesString = coordinates
          .map((coord) => coord.join(","))
          .join(";");
        const route = await navigation(coordinatesString);
        // console.log("Ruta", route);
        dispatch(
          setCoordinates({ coordinates: route?.geometry?.coordinates ?? [] })
        );
        dispatch(setLandMarks({ landMarks: coordinates }));
        dispatch(
          setDataRoute({
            distance: route?.distance ?? 0,
            estimatedTime: route?.duration ?? "0 min",
          })
        );
        setOptionsPlacesEnd([]);
      }
      setLoading(false);
    } catch (error) {
      // setOptionsPlaces([]);
      setLoading(false);
      toast.error("No se encontraron resultados. \nIntentalo más tarde.");
    }
  };
  return (
    <Box
      sx={{
        display: "flex",
        width: 280,
        flexDirection: "column",
        gap: 2,
      }}
    >
      <Box sx={{ width: "100%", position: "relative" }}>
        <TextField
          label="Inicio de la Ruta"
          name="initRoute"
          variant="filled"
          style={{
            backgroundColor: "black",
            borderRadius: 5,
            width: "100%",
          }}
          onChange={(e) => handlePlaceOption(e)}
        />
        <Box
          sx={{
            width: "100%",
            maxWidth: 360,
            bgcolor: "background.paper",
            position: "absolute",
            zIndex: 999,
          }}
        >
          {optionsPlacesInit.length > 0 &&
            optionsPlacesInit.map(
              (place, key) =>
                place?.properties?.full_address && (
                  <List key={key}>
                    <ListItem>
                      <ListItemButton
                        onClick={() => onPressPlace(place, "initRoute")}
                      >
                        <ListItemIcon>
                          <FmdGoodIcon />
                        </ListItemIcon>
                        <ListItemText
                          primary={`${place?.properties?.full_address}`}
                        />
                      </ListItemButton>
                    </ListItem>
                  </List>
                )
            )}
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          position: "absolute",
          left: -35,
          top: 100,
        }}
      >
        <AdjustIcon
          style={{
            color: "black",
            fontSize: 25,
          }}
          fontSize="large"
        />
        <MoreVertIcon
          style={{
            color: "black",
            fontSize: 30,
          }}
          fontSize="large"
        />
        <ModeOfTravelIcon
          style={{
            color: "black",
            fontSize: 25,
          }}
          fontSize="large"
        />
      </Box>
      <ImportExportIcon
        style={{
          color: "black",
          fontSize: 40,
          position: "absolute",
          right: -40,
          top: 120,
        }}
      />
      <Box sx={{ width: "100%", position: "relative" }}>
        <TextField
          label="Fin de la Ruta"
          name="endRoute"
          variant="filled"
          style={{
            backgroundColor: "black",
            borderRadius: 5,
            width: "100%",
          }}
          onChange={(e) => handlePlaceOption(e, "endRoute")}
        />
        <Box
          sx={{
            width: "100%",
            maxWidth: 360,
            bgcolor: "background.paper",
            position: "absolute",
            zIndex: 999,
          }}
        >
          {optionsPlacesEnd.length > 0 &&
            optionsPlacesEnd.map(
              (place, key) =>
                place?.properties?.full_address && (
                  <List key={key}>
                    <ListItem>
                      <ListItemButton
                        onClick={() => onPressPlace(place, "endRoute")}
                      >
                        <ListItemIcon>
                          <FmdGoodIcon />
                        </ListItemIcon>
                        <ListItemText
                          primary={`${place?.properties?.full_address}`}
                        />
                      </ListItemButton>
                    </ListItem>
                  </List>
                )
            )}
        </Box>
      </Box>
    </Box>
  );
};

export default FormGenerateNewRoute;
